import ClipboardJS from 'clipboard';

export default class CopyToClipboard {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        this.copyToClipboard();
    }

    copyToClipboard() {
        if (document.getElementsByClassName("marketing-section")) {
            // const textToCopy = document.getElementsByClassName('text-to-copy')[0];
            // const clipboard = navigator.clipboard;
            // if (clipboard === undefined) {
            //     console.log('clipboard is undefined');
            // } else {
            //     textToCopy.select();
            //     textToCopy.setSelectionRange(0, 99999); /* For mobile devices */
            //     console.log(textToCopy.value)
            //     navigator.clipboard.writeText(textToCopy.value);
            // }

            new ClipboardJS('.btn-clipboard');
        }
    }
}
